module.exports = __webpack_public_path__ + "img/page10.df6913d7.png";